<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading && !records" :color="loadingColor" style="text-align: center"/>
        <div v-if="records" class="drugs_list">

          <div class="loading_block" v-if="loading">
            <div class="cover-loading">
              <pulse-loader :loading="true" :color="loadingColor" style="text-align:center"/>
            </div>
          </div>

          <div class="form-group">
            <input @change="updateRecords" v-model="showMyProjects" type="checkbox" id="ch_1">
            <label class="ml-1 pointer" for="ch_1">Показать только мои проекты</label>
          </div>
          <div class="row">
            <div v-for="column in [1,2]" class="col-md-6">
              <table class="table table-sm table-hover">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Препарат</th>
                  <th>Запрос</th>
                  <th>На складе</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(drug, i) in getSortedDrugs()">
                  <template
                    v-if="i < (Math.round(Object.keys(drugs).length / 2) * column) && i >= (Math.round(Object.keys(drugs).length / 2) * (column -1))">
                    <tr>
                      <td>{{ drug.id }}</td>
                      <td>{{ drug.title }}</td>
                      <td>{{ getRequestedQty(drug.id) }}</td>
                      <td>{{ getRemainQty(drug.id) }}</td>
                    </tr>
                  </template>
                </template>
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <table v-if="extraDrugs.length" class="table mt-0 table-sm table-hover table-small-td">
              <tbody>
              <tr v-for="(d,i) in extraDrugs">
                <td>{{ i + 1 }}</td>
                <td>{{ d.title }}</td>
                <td>
                  <button type="button" @click="extraDrugs = extraDrugs.filter((dd) => dd.id !== d.id)"
                          class="btn btn-outline-danger btn-sm"><i class="icon-fa icon-fa-trash"/></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
    <div class="card" v-if="records">
      <div class="card-body">
        <div v-if="loading">
          <pulse-loader :loading="loading" :color="loadingColor" style="text-align: center"/>
        </div>
        <div v-else>
          <p v-if="paginator">Всего заявок: <strong>{{ paginator.total }}</strong></p>
          <paginate v-if="paginator"
                    v-model="currentPage"
                    :page-count="paginator.last_page"
                    :page-range="8"
                    :margin-pages="2"
                    :click-handler="getRequestedDrugs"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
          <ordersList
            :orders="records"
          />
          <paginate v-if="paginator"
                    v-model="currentPage"
                    :page-count="paginator.last_page"
                    :page-range="8"
                    :margin-pages="2"
                    :click-handler="getRequestedDrugs"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import ordersList from '@/components/orders/ordersList'
import Paginate from 'vuejs-paginate'

export default {
  components: {
    ordersList,
    Paginate,
  },
  data() {
    return {
      loading: false,
      records: null,
      availableDrugs: null,
      drugs: null,
      loadingColor: this.$constants.LOADING_COLOR,
      paginator: null,
      currentPage: 1,
      selectedStore: 3,
      showMyProjects: true,
      extraDrugs: [],
    }
  },
  created() {
    this.getRequestedDrugs()
  },
  methods: {
    updateRecords() {
      this.currentPage = 1;
      this.getRequestedDrugs();
    },
    getRequestedQty(drugId) {
      return this.availableDrugs[drugId].customerRequest;
      return (this.availableDrugs[drugId].orders || []).reduce((acc, o) => {
        if (o.drug_id === drugId) acc += o.qty;
        return acc;
      }, 0)
    },
    getRemainQty(drugId) {
      return this.availableDrugs && this.availableDrugs[drugId] && this.availableDrugs[drugId].remain && this.availableDrugs[drugId].remain[this.selectedStore] || 0
    },
    getSortedDrugs() {
      return _.orderBy(Object.values(this.drugs), 'title')
    },
    async getRequestedDrugs(page = null) {
      if (!page) page = this.currentPage;
      this.loading = true;
      const {data: r_data} = await api.post('/new/orders/requestedDrugs', {
        page: page,
        showMyProjects: this.showMyProjects
      });
      if (!r_data.success) {
        toastr['warning'](r_data.message || 'Ошибка сервера');
      } else {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination
        this.currentPage = this.paginator.current_page
        this.records = data
        this.drugs = r_data.drugs
        this.availableDrugs = r_data.availableDrugs
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>

.drugs_list {
  position: relative;
}

.loading_block {
  position: absolute;
  height: 100%;
  z-index: 1;
  width: 100%;
  background-color: rgb(255, 255, 255, .7);
}

.cover-loading {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
